import React from "react";
import useSortingDataByWeek from "./useSortingDataByWeek";

export default function useListCommandes() {
	const [data, setData] = React.useState(null);
	const [loadingData, setLoadingData] = React.useState(true);
	const [errorData, setErrorData] = React.useState(null);

	const { ancienneData, actuelleData, futurData } = useSortingDataByWeek(
		data,
		"commande"
	);

	const fetchDataCommandes = React.useCallback(async () => {
		try {
			const response = await fetch("/api/listCommandes");
			if (!response.ok) throw new Error(`Erreur API ${response.status}`);
			const data = await response.json();
			setData(data);
		} catch (err) {
			setErrorData(err.message);
		} finally {
			setLoadingData(false);
		}
	}, []);

	React.useEffect(() => {
		fetchDataCommandes();
	}, [fetchDataCommandes]);

	const ancienneCommandes = ancienneData ? ancienneData : null;
	const commandeEnCours = actuelleData ? actuelleData : null;
	const prochaineCommandes = futurData ? futurData : null;

	return {
		ancienneCommandes,
		commandeEnCours,
		prochaineCommandes,
		loadingData,
		errorData,
		fetchDataCommandes,
	};
}
